import { useQuery } from 'react-query';

import {
  NEWSLETTER_SUBSCRIPTION_KEY,
  NewsletterSubscriptionStatus,
  getNewsletterSubscriptionStatus,
} from '@utils/backend-api/newsletters';

export default function useCurrentNewsletterSubscription(
  newsletterId: number | string,
  enabled = true
) {
  const { data, isFetching, isLoading } = useQuery<NewsletterSubscriptionStatus>(
    [NEWSLETTER_SUBSCRIPTION_KEY, newsletterId?.toString()],
    () => getNewsletterSubscriptionStatus({ newsletter_id: newsletterId }),
    {
      enabled: enabled && !!newsletterId,
    }
  );
  return {
    isSubscribed: data?.isSubscribed,
    isLoadingSubscribed: isLoading,
    status: isFetching,
  };
}
